
import { Navigate, useLocation } from 'react-router-dom';
import React from 'react';
import { useUserProfile } from '../contexts/user/UserContext';

interface PrivateRouteProps {
  element: React.ReactNode;
}

const PrivateRoute: React.FC<PrivateRouteProps> = ({ element }) => {
  const { user } = useUserProfile();
  const location = useLocation();

  return (
    <React.Fragment>
      {user ? element : <Navigate to={'/'} state={{ from: location }} replace={true} />}
    </React.Fragment>
  );
};

export default PrivateRoute;
